// External library
import { Modal } from 'bootstrap' // eslint-disable-line no-unused-vars

// Component
export default () => {
    const announcements = document.querySelectorAll('[data-announcement]') // announcement selector
    const showCss = 'show'

    // If there's no announcement, return
    if (!announcements)
        return

    const getStorage = () => {
        return JSON.parse(
            window.localStorage.getItem('announcementsDismiss')
        )
    }

    const setStorage = (value) => {
        window.localStorage.setItem(
            'announcementsDismiss',
            JSON.stringify(value)
        )
    }

    const storage = getStorage() || {}

    const loadAnnouncements = (el) => {
        const { announcementName: name, announcementUpdated: updated } = el.dataset
        const isModal = el.classList.contains('modal')
        const isToast = el.classList.contains('toast')

        const eventType = isModal
            ? 'hide.bs.modal'
            : (isToast
                ? 'hide.bs.toast'
                : 'click')

        if (storage[name]
            && storage[name] === updated
        )
            return

        if (isModal)
            new Modal(el).show()
        else
            el.classList.add(showCss)

        el.addEventListener(
            eventType,
            dismiss
        )
    }

    const dismiss = (e) => {
        const target = e.target
        const wrapper = target.closest('[data-announcement]')
        const { announcementName: name, announcementUpdated: updated } = wrapper.dataset

        if (target.closest('[data-announcement-dismiss]')
            || e.type === 'hide.bs.modal'
            || e.type === 'hide.bs.toast'
        ) {
            const current = storage

            if (!current[name]
                || current[name] !== updated
            ) {
                current[name] = updated
                setStorage(current)
                wrapper.classList.remove(showCss)
            }
        }
    }

    announcements.forEach(el => loadAnnouncements(el))
}
